import { toast } from "../components/razor-reuse";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../utils/axios";
import { NotificationState } from "./type";

export const getAllNotification = createAsyncThunk(
  "web/get-all-notification",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/notifications?type=${payload?.type || "all"}`
      );
      

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;
        
        thunkAPI.dispatch(SET_NOTIFICATION(obj));
      }
      return data?.data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const getUnreadNotification = createAsyncThunk(
  "web/get-unread-notification",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(`/admin/notifications?type=unread`);
      

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      // if (data?.data?.status) {
      //   const obj = data?.data?.data;
      //     
      //   thunkAPI.dispatch(SET_NOTIFICATION(obj));
      // }
      return data?.data?.data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const markAllNotification = createAsyncThunk(
  "web/mark-all-notification",
  async (payload: any, { rejectWithValue, dispatch }) => {
    try {
      const data = await axios.post(`/admin/notifications/read-all`);
      

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return rejectWithValue(data);
      }
      if (data?.data?.status) {
        dispatch(getAllNotification({}));
        dispatch(getUnreadNotification({}));
      }
      return data?.data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return rejectWithValue(error);
      }
      return error;
    }
  }
);

export const markNotificationRead = createAsyncThunk(
  "web/mark-notification-read",
  async (payload: any, { rejectWithValue, dispatch }) => {
    try {
      const data = await axios.post(
        `/admin/notifications/read/${payload?.id || ""}`
      );
      

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return rejectWithValue(data);
      }
      if (data?.data?.status) {
        dispatch(getAllNotification({}));
        dispatch(getUnreadNotification({}));
      }
      return data?.data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return rejectWithValue(error);
      }
      return error;
    }
  }
);

export const deleteNotification = createAsyncThunk(
  "web/delete-notification",
  async (payload: any, { rejectWithValue, dispatch }) => {
    try {
      const data = await axios.delete(
        `/admin/notifications/${payload?.id || ""}`
      );
      

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return rejectWithValue(data);
      }
      if (data?.data?.status) {
        dispatch(getAllNotification({}));
        dispatch(getUnreadNotification({}));
        return data?.data;
      }
      return data?.data;
    } catch (error: any) {
      //   console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return rejectWithValue(error);
      }
      return error;
    }
  }
);

const initialState: NotificationState = {
  loading: false,
  notification_data: [],
  unread_notification: 0,
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,

  reducers: {
    SET_NOTIFICATION: (state, action) => {
      state.notification_data = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getAllNotification.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllNotification.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(getAllNotification.rejected, (state) => {
      state.loading = false;
      return initialState;
    });
    builder.addCase(markAllNotification.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(markAllNotification.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(markAllNotification.rejected, (state) => {
      state.loading = false;
      return initialState;
    });
    builder.addCase(markNotificationRead.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(markNotificationRead.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(markNotificationRead.rejected, (state) => {
      state.loading = false;
      return initialState;
    });
    builder.addCase(deleteNotification.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteNotification.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteNotification.rejected, (state) => {
      state.loading = false;
      return initialState;
    });
    builder.addCase(getUnreadNotification.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUnreadNotification.fulfilled, (state, action) => {
      state.loading = false;
      state.unread_notification = action.payload?.length;
    });
    builder.addCase(getUnreadNotification.rejected, (state) => {
      state.loading = false;
      return initialState;
    });
  },
});

// Action creators are generated for each case reducer function
export const { SET_NOTIFICATION } = notificationSlice.actions;

export default notificationSlice.reducer;
